/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import Grid from '../../components/Grid/Grid';
import Skeleton from '../../components/Skeleton/Skeleton';
import occasionStyle from './Occasion.scss';
import s from './OccasionSkeleton.scss';

const DESCRIPTION_LINE_HEIGHT = '20px';

const OccasionSkeleton = ({ isDesktop }) => {
  return (
    <div className={occasionStyle.root}>
      <div className={occasionStyle.banner}>
        <Skeleton width="100%" height="400px" />
      </div>
      <div className={occasionStyle.container}>
        <div className={occasionStyle.content}>
          {isDesktop ? (
            <Grid
              container
              spacing="fluid"
              justify="center"
              className={s.cards}
            >
              <Grid item xs={12} sm={6} md={4}>
                <OccasionItemSkeleton />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <OccasionItemSkeleton />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <OccasionItemSkeleton />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <OccasionItemSkeleton />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <OccasionItemSkeleton />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <OccasionItemSkeleton />
              </Grid>
            </Grid>
          ) : (
            <div className={s.mobileCards}>
              <OccasionItemSkeleton />
              <OccasionItemSkeleton />
              <OccasionItemSkeleton />
            </div>
          )}

          <div className={occasionStyle.description}>
            <div className={s.paragraph}>
              <Skeleton
                width="300px"
                height={DESCRIPTION_LINE_HEIGHT}
                className={s.title}
              />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="250px" height={DESCRIPTION_LINE_HEIGHT} />
            </div>
            <div className={s.paragraph}>
              <Skeleton
                width="500px"
                height={DESCRIPTION_LINE_HEIGHT}
                className={s.title}
              />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="400px" height={DESCRIPTION_LINE_HEIGHT} />
            </div>
            <div className={s.paragraph}>
              <Skeleton
                width="350px"
                height={DESCRIPTION_LINE_HEIGHT}
                className={s.title}
              />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="100%" height={DESCRIPTION_LINE_HEIGHT} />
              <Skeleton width="500px" height={DESCRIPTION_LINE_HEIGHT} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const OccasionItemSkeleton = () => {
  return (
    <div className={s.skeletonCard}>
      <Skeleton width="100%" height="130px" />
      <div className={s.cardContent}>
        <Skeleton width="100%" height="22px" className={s.cardTitle} />
        <div className={s.cardDescription}>
          <Skeleton width="100%" height="16px" />
          <Skeleton width="50%" height="16px" />
        </div>
        <Skeleton width="65px" height="16px" />
      </div>
    </div>
  );
};

OccasionSkeleton.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
};

export default compose(
  withResponsiveWrapper(),
  withStyles(occasionStyle, s),
)(OccasionSkeleton);
